module.exports = __webpack_public_path__ + "static/the_deep-0ee9c6f06786f8dcdc9695b0be5c1f64.jpg";